import React, { useEffect } from "react";
import { motion } from "framer-motion";
import HeroSection from "./SoftwareDevelopmentHome/HeroSection";
import ServicesGrid from "./SoftwareDevelopmentHome/ServicesGrid";
import WhyChooseUs from "./SoftwareDevelopmentHome/WhyChooseUs";
import ProcessSection from "./SoftwareDevelopmentHome/ProcessSection";
import FAQSection from "./SoftwareDevelopmentHome/FAQSection";
import CTASection from "./SoftwareDevelopmentHome/CTASection";


const SoftwareDevelopmentHome = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, []);

  return (
    <motion.main
      initial={{
        opacity: 0,
      }}
      animate={{
        opacity: 1,
      }}
      transition={{
        duration: 0.45,
        ease: "easeOut",
      }}
      className="
        relative
        min-h-screen
        overflow-hidden
        bg-[#050505]
        text-white
        font-saira
      "
    >
    
      <HeroSection />
      <ServicesGrid />
      <WhyChooseUs />
      <ProcessSection />
      <FAQSection />
      <CTASection />

    </motion.main>
  );
};

export default SoftwareDevelopmentHome;